import { toast } from "react-toastify";

import { PORTFOLIO_NAME_IN_API_BODY } from "../../enums/AssetOverview/portfolio";
import { ENERGY_DASHBOARD_NAME_API_BODY } from "../../enums/energyDashboard";
import i18next from "../../i18n";
import { clearStoreAndLocalStorage, customApiCall, customPaginatedApi1PageNoLimitCall } from "../../utils/axios";
import { getUserFromLocalStorage } from "../../utils/localStorage";
import apiUrls from "../urls";

export const postTranslation = async ({ data, method }) => {
  const url = apiUrls.translation.get("de");
  const resp = await customApiCall[method]({ data, url });
  return resp;
};

export const postSelectedColumns = async ({ data }) => {
  const url = apiUrls.technicalData.selectedColumns.post;
  const resp = await customApiCall.post({ data, url });
  return resp;
};

export const patchParentFiles = async ({ activeTab, data, rowId }) => {
  const url = apiUrls.layerFiles.techData[activeTab].detail(rowId);
  const resp = await customApiCall.patch({ data, url });
  return resp;
};

export const postParentRow = async ({ activeTab, data }) => {
  const url = apiUrls.layerFiles.techData[activeTab].post();
  const resp = await customApiCall.post({ data, url });
  return resp;
};

export const postChildRow = async ({ activeTab, data }) => {
  const url = apiUrls.layerFiles.techData[activeTab].layerPost();
  const resp = await customApiCall.post({ data, url });
  return resp;
};

export const deleteParentFilesRow = async ({ activeTab, rowId }) => {
  const url = apiUrls.layerFiles.techData[activeTab].detail(rowId);
  const resp = await customApiCall.delete({ url });
  return resp;
};

export const postChildFiles = async ({ activeTab, data, layerId }) => {
  const url = apiUrls.layerFiles.techData[activeTab].layerDetail(layerId);
  const resp = await customApiCall.patch({ data, url });
  return resp;
};

export const deleteChildFilesRow = async ({ activeTab, layerId }) => {
  const url = apiUrls.layerFiles.techData[activeTab].layerDetail(layerId);
  const resp = await customApiCall.delete({ url });
  return resp;
};
export const getParentFiles = async ({ activeTab, projectId }) => {
  const url = apiUrls.layerFiles.techData[activeTab]?.list(projectId);

  if (apiUrls.layerFiles.techData[activeTab]?.paginated) return await customPaginatedApi1PageNoLimitCall.get({ url });
  else return await customApiCall.get({ url });
};

export const getChildFiles = async ({ activeTab, layerId }) => {
  const url = apiUrls.layerFiles.techData[activeTab].layerList(layerId);
  const resp = await customApiCall.get({ url });
  return resp;
};

// Energy Performance
export const getDashboardNew = async (inputs) => {
  const url = apiUrls.energyPerformanceNew.data.listFlatten(inputs);
  const resp = await customApiCall.get({ url });
  const columns = resp[0]?.columns;
  const allValues = resp[0]?.values;

  const reformattedValues = allValues?.map((oneRowValuesArray) => {
    const keyValueFormatRow = {};
    columns?.forEach((col, index) => {
      keyValueFormatRow[col] = oneRowValuesArray[index];
    });
    return keyValueFormatRow;
  });
  return { columns, reformattedValues };
};

export const getProjectInfo = async (projectId) => {
  const url = apiUrls.energyPerformanceNew.projectInfo.list(projectId);
  const resp = await customApiCall.get({ url });
  return resp;
};

export const updateUserLanguage = (userId, language) => {
  const url = apiUrls.user.detail(userId);
  const data = { languages: language };
  customApiCall.patch({ data, url });
};
export const loginUser = (user) => {
  const basicAuthKey = `${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`;
  const headers = {
    Authorization: "Basic " + window.btoa(basicAuthKey),
  };
  var data = new FormData();
  data.append("username", user.username);
  data.append("password", user.password);
  data.append("grant_type", "password");

  return customApiCall.post({
    data: data,
    headers,
    url: apiUrls.user.login.url,
    useToken: false,
  });
};

export const logoutUser = async (message) => {
  try {
    var data = new FormData();
    const user = getUserFromLocalStorage();
    data.append("token", user?.access_token);
    data.append("client_id", process.env.REACT_APP_BASIC_AUTH_USERNAME);
    data.append("client_secret", process.env.REACT_APP_BASIC_AUTH_PASSWORD);
    await customApiCall.post({
      data: data,
      url: apiUrls.user.logout.url,
      useToken: false,
    });
    if (message) toast.success(message);
  } catch (error) {
    // DO nothing
  } finally {
    clearStoreAndLocalStorage();
  }
};

export const downloadCertificateFiles = ({ certificateType, projectId }) => {
  const url = apiUrls.files.certificates.download(projectId, certificateType);
  const fileName = certificateType + ".zip";
  const errorMessage = i18next.t("general.downloadFileProblem");
  customApiCall.download({ errorMessage, fileName, url });
};

export const postEnergyDashboardConfigs = async ({ data, projectId }) => {
  const url = apiUrls.dynamicDashboard.configs.post();
  const payload = { config: data, config_filter: ENERGY_DASHBOARD_NAME_API_BODY, project_id: Number(projectId) };

  const resp = await customApiCall.post({ data: JSON.stringify(payload), url });
  return resp;
};

export const deleteEnergyDashboardConfigs = async ({ projectId }) => {
  const url = apiUrls.dynamicDashboard.configs.delete(projectId, ENERGY_DASHBOARD_NAME_API_BODY);

  const resp = await customApiCall.delete({ url });
  return resp;
};

export const postPortfolioDashboardConfigs = async ({ data, userId }) => {
  const url = apiUrls.dynamicDashboard.configs.post();
  const payload = { config: data, config_filter: PORTFOLIO_NAME_IN_API_BODY, user_id: Number(userId) };

  const resp = await customApiCall.post({ data: JSON.stringify(payload), url });
  return resp;
};

export const deletePortfolioDashboardConfigs = async ({ userId }) => {
  const url = apiUrls.dynamicDashboard.configs.delete(userId, PORTFOLIO_NAME_IN_API_BODY);

  const resp = await customApiCall.delete({ url });
  return resp;
};

export const deleteBuildingProfileFile = async ({ fileId }) => {
  const url = apiUrls.layerFiles.buildingPassport.detail(fileId);
  const resp = await customApiCall.delete({ url });
  return resp;
};
